import { memo } from "react";
import { Button, Tooltip } from "@/components";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { clsx } from "clsx";

interface AssetSectionHeaderProps {
    title: string;
    onCopyPrevious: () => void;
    onMatchDistribution: () => void;
    tooltip?: string;
    slotProps?: {
        title?: React.HTMLAttributes<HTMLHeadingElement>;
    };
}

function AssetSectionHeaderBase({
    title,
    onCopyPrevious,
    onMatchDistribution,
    tooltip = "",
    slotProps = {
        title: {},
    },
}: AssetSectionHeaderProps) {
    const titleClsx = clsx(
        "text-[20px] text-primary font-medium flex justify-start items-center gap-2",
        slotProps.title?.className,
    );

    return (
        <div className="flex items-center justify-between">
            <h2 {...slotProps.title} className={titleClsx}>
                {title}

                {tooltip && (
                    <Tooltip title={tooltip}>
                        <span className="inline-block cursor-help">
                            <Button variant="ghost" size="sm" className="p-0 min-w-0 flex items-center">
                                <InformationCircleIcon className="text-dark text-xs w-4 h-4" />
                            </Button>
                        </span>
                    </Tooltip>
                )}
            </h2>
            <div className="flex-col mb-2 md:flex-row flex md:space-x-4">
                <Button
                    variant="text"
                    className="text-primary underline text-[12px]"
                    size="sm"
                    onClick={onCopyPrevious}
                >
                    Copy previous votes
                </Button>
                <Button
                    variant="text"
                    className="text-primary underline text-[12px]"
                    size="sm"
                    onClick={onMatchDistribution}
                >
                    Match current distribution
                </Button>
            </div>
        </div>
    );
}

export const AssetSectionHeader = memo(AssetSectionHeaderBase);

AssetSectionHeader.displayName = "AssetSectionHeader";
